'use strict';

// Ugh. Need to do this and include the files manually, since they are loaded
// though Angular DI to the controllers, but for leaflet libraries we don't
// have the DI mechanism and need to load it ourselves
var config = require('./../../../../../config/config');
var MapConfig = require('./../../../../../config/MapConfig');

var mapConfig = new MapConfig(config);

var _ = require('lodash');

module.exports = {
  isOverlay: function (layer) {
    var type;

    if (typeof layer === 'string') {
      type = layer.toLowerCase();
    } else {
      console.log('DEPRECATED');
      type = layer.type.toLowerCase();
    }

    return type === 'overlay';
  },

  getLeafletLayer: function (rlayer, renderOptions) {
    var options = mapConfig.getTileLayer('overlay', rlayer.overlay.id, renderOptions);
    var layerOptions = _.extend({}, options.layerOptions, { layerId: rlayer.overlay.id });

    var layer = L.tileLayer(options.url, layerOptions);
    if(rlayer.overlay.opacity !== undefined) {
      layer.setOpacity(rlayer.overlay.opacity);
    }
    return layer;
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/annotation/lib/OverlayUtil.js